var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Checkout-Desktop--January","stroke":"none","strokeWidth":"1","fillRule":"evenodd","transform":"translate(-1317 -22)"},React.createElement("g",{"id":"Group-15","transform":"translate(1317 21)"},React.createElement("g",{"id":"arrow462","transform":"translate(0 1)"},React.createElement("path",{"d":"M15.647 6.814a1.156 1.156 0 00-.919-.41H7.076l3.185-3.196c.275-.276.413-.607.413-.993 0-.385-.138-.717-.413-.993L9.446.415A1.335 1.335 0 008.468 0c-.384 0-.714.138-.99.415L.402 7.507A1.4 1.4 0 000 8.5c0 .386.134.713.402.982l7.076 7.114c.283.27.613.404.99.404.384 0 .71-.135.978-.404l.815-.829c.275-.262.413-.59.413-.982a1.3 1.3 0 00-.413-.982l-3.185-3.208h7.652c.377 0 .683-.136.919-.41A1.46 1.46 0 0016 9.199V7.802a1.46 1.46 0 00-.353-.988z","id":"Shape"})))));
}

ArrowLeft.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
